import React from 'react'
import PropTypes from 'prop-types'
import css from './style.css'

const Grid = props => {
  var classes = [
    css.grid,
    props.nopad ? css.nopad : '',
    props.customStyle
  ]
  return (
    <div className={classes.join(' ')} style={props.style}>
      {props.children}
    </div>
  )
}

const GridItem = props => {
  var columns = props.col.split('/')
  var percent = columns[0] / columns[1] * 100

  let classNames = [
    css.gridItem,
    props.customStyle,
    props.nopad ? css.nopad : '',
    props.mobileFullWidth ? css.mobileFullWidth : '',
    props.tabletFullWidth ? css.tabletFullWidth : '',
    props.pullRight ? css.pullRight : ''
  ]

  let style = props.style || {}
  style.width = `${percent}%`

  return (
    <div style={style} className={classNames.join(' ')}>
      {props.children}
    </div>
  )
}

const demoStyle = {
  backgroundColor: '##fafbfc',
  border: '1px solid #ccc',
  padding: '10px',
  marginBottom: '20px'
}

const GridDemo = props => (
  <Grid>
    <GridItem col='1/1'>
      <div style={demoStyle}>Full width</div>
    </GridItem>
    <GridItem col='1/2' tabletFullWidth>
      <div style={demoStyle}>Full width tablet</div>
    </GridItem>
    <GridItem col='1/2' tabletFullWidth>
      <div style={demoStyle}>Full width tablet</div>
    </GridItem>
    <GridItem col='1/10' mobileFullWidth><div style={demoStyle}>Full width mobile</div></GridItem>
    <GridItem col='1/10' mobileFullWidth><div style={demoStyle}>Full width mobile</div></GridItem>
    <GridItem col='1/10' mobileFullWidth><div style={demoStyle}>Full width mobile</div></GridItem>
    <GridItem col='1/10' mobileFullWidth><div style={demoStyle}>Full width mobile</div></GridItem>
    <GridItem col='1/10' mobileFullWidth><div style={demoStyle}>Full width mobile</div></GridItem>
    <GridItem col='1/10' mobileFullWidth><div style={demoStyle}>Full width mobile</div></GridItem>
    <GridItem col='1/10' mobileFullWidth><div style={demoStyle}>Full width mobile</div></GridItem>
    <GridItem col='1/10' mobileFullWidth><div style={demoStyle}>Full width mobile</div></GridItem>
    <GridItem col='1/10' mobileFullWidth><div style={demoStyle}>Full width mobile</div></GridItem>
    <GridItem col='1/10' mobileFullWidth><div style={demoStyle}>Full width mobile</div></GridItem>
  </Grid>
)

GridItem.propTypes = {
  col: PropTypes.string.isRequired
}

export { Grid, GridItem, GridDemo }



// WEBPACK FOOTER //
// ./src/components/grid/index.js